import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import DrawColor from '../../components/ExcerciseTypes/DrawColor';

const json = {
  1: { // Exercise num
    unit: 'Unit 11',
    id: 'WB3-U11-P77-E1',
    audio: '',
    video: '',
    component: T6,
    stylesTextInput: { backgroundColor: 'transparent', border: 'none', padding: 0 },
    exerciseKey: 'img/FriendsPlus/Page77/E1/Key/answerKey.png',
    inputSize: 140,
    // titleImage: "img/FriendsPlus/Page60/E1/1.jpg",
    // titleQuestion: [{ num: '1', title: 'Read the sentences and number the picture.', color: "#5B5A5D" }],
    questionImage: [],
    questions: [
      {
        title: `
        <div style=" position: relative; ">
          <div> <img src='img/FriendsPlus/Page77/E1/1.jpg' /> </div>
          <div style=" position: absolute; top: 211px; left: 289px; "><input id='0' /></div>
          <div style=" position: absolute; top: 210px; left: 533px; "><input id='1' /></div>
          <div style=" position: absolute; top: 211px; left: 783px; "><input id='2' /></div>
        </div>
        `,
        answer: [
          "tree",
          "three",
          "cheese",

        ],
      },
    ],
  },
  2: {
    unit: 'Unit 11',
    id: 'WB3-U11-P77-E2',
    audio: 'img/FriendsPlus/Page77/Audio/audio-e2-p77.mp3',
    video: '',
    component: D1,
    titleImage: '',
    exerciseKey: 'img/FriendsPlus/Page77/E2/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page77/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page77/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page77/E2/3.jpg', audioUrl: 'img/FriendsPlus/Page77/Audio/tieude-e2-p77.mp3' },
        { url: 'img/FriendsPlus/Page77/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page77/E2/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page77/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page77/E2/7.jpg', input: true, answer: "feet" },
        { url: 'img/FriendsPlus/Page77/E2/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page77/E2/9.jpg' },
        { url: 'img/FriendsPlus/Page77/E2/10.jpg', input: true, answer: "three" },
        { url: 'img/FriendsPlus/Page77/E2/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page77/E2/12.jpg' },
        { url: 'img/FriendsPlus/Page77/E2/13.jpg', input: true, answer: "cheese" },
        { url: 'img/FriendsPlus/Page77/E2/14.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page77/E2/15.jpg' },
      ],
    ]
  },
  3: { // Exercise num
    unit: 'Unit 11',
    id: 'WB3-U11-P77-E3',
    audio: '',
    video: '',
    component: DrawColor,
    exerciseKey: 'img/FriendsPlus/Page77/E3/Key/answerKey.png',
    titleQuestion: [{ num: '3', title: 'Read. Circle the words with ee. Underline the words with e', color: "#5B5A5D" }],
    question: {
      Write: {
        underlineStyle: {},
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        listStyle: {
          normal: {},
          circle: { padding: 3, border: 'solid 2px', borderRadius: '50%', borderColor: 'gray' },
          underline: { borderBottom: '2px solid gray' },
          // square: { padding: 3, border: 'solid 2px', borderColor: '#4285F4' },
        },
        // limitSelect: 1,
        listWords: [
          "There are three monkeys in the tree.",	//0
          "My bed is red.",	//0
        ],
        answers: { '0-12': 'circle', '0-4': 'circle', '0-6': 'underline', '1-2': 'underline', '1-6': 'underline' },
        initialValue: {},
      },
      Layout: `
          <div style="
                  display: flex;
                  flex-direction: column;
                  transform: translateX(20px)
                  ">
          <img src="img/FriendsPlus/Page77/E3/1.jpg" />
          <div style="display: flex; justify-content: space-around; transform: translate(-3.3%)"> 
            <span> This <u> pen </u> is <span style="border: 2px solid gray;padding:3px; border-radius: 50%;">green</span>.  </span>
            <span ><input id='0' type='Circle' /></span>
            <span><input id='1' type='Circle' /></span>
          </div>
          </div>
      `,
    },
  },
  4: { // Exercise num
    unit: 'Unit 11',
    id: 'WB3-U11-P77-E4',
    audio: '',
    video: '',
    component: T6,
    checkDuplicated: true,
    isHiddenCheck: true,
    stylesTextInput: { backgroundColor: 'transparent', border: 'none', padding: 0 },
    exerciseKey: 'img/FriendsPlus/Page77/E4/Key/answerKey.png',
    inputSize: 190,
    // titleImage: "img/FriendsPlus/Page60/E1/1.jpg",
    // titleQuestion: [{ num: '1', title: 'Read the sentences and number the picture.', color: "#5B5A5D" }],
    questionImage: [],
    questions: [
      {
        title: `
        <div style=" position: relative; ">
          <div> <img src='img/FriendsPlus/Page77/E4/1.jpg' /> </div>
          <div style=" position: absolute; top: 154px; left: 70px "><input id='0' /></div>
          <div style=" position: absolute; top: 205px; left: 70px "><input id='1' /></div>
          <div style=" position: absolute; top: 106px; left: 338px "><input id='2' /></div>
          <div style=" position: absolute; top: 156px; left: 338px "><input id='3' /></div>
          <div style=" position: absolute; top: 206px; left: 338px "><input id='4' /></div>
        </div>
        `,
        answer: [
          "three/tree",
          "three/tree",
          "pen/bed/red",
          "pen/bed/red",
          "pen/bed/red",

        ],
      },
    ],
  },




}
export default json;